function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var GameCardStackTemplate = require('./game-cardstack.template');
var GameCardStack = /*#__PURE__*/function () {
  function GameCardStack(app, mod, uuid) {
    _classCallCheck(this, GameCardStack);
    this.app = app;
    this.mod = mod;
    this.orientation = 'down'; // or up, left, right, center
    this.card_width = 120; // px
    this.card_height_ratio = 1.53;

    // We duplicate the internal game storage of the card stack
    this.cards = [];

    // A ratio for determinining what fraction of the card width/height is covered by the next card
    this.overlap = 6;

    /*
     * It is strongly recommended that game modules use a grid layout and
     * carefully manage the position of the card stacks on the game board
     */
    this.container = '.cardstack-container';

    /*
     * Since there are often going to be multiple card stacks, we need a unique name
     */
    this.name = uuid;
  }
  return _createClass(GameCardStack, [{
    key: "render",
    value: function render() {
      var selector = "cardstack_".concat(this.name);
      if (document.getElementById(selector)) {
        //Update card_width... this allows dynamic css card sizing
        var card_obj = document.querySelector("#cardstack_".concat(this.name, " .card-slot"));
        if (card_obj) {
          this.card_width = Math.round(card_obj.getBoundingClientRect().width);
        }
        this.app.browser.replaceElementById(GameCardStackTemplate(this), selector);
      } else {
        this.app.browser.addElementToSelector(GameCardStackTemplate(this), this.container);
      }
      if (this.cards.length == 0) {
        return;
      }

      //If we have cards to stack let's do some math to figure out how to space them out smartly

      var container_obj = document.getElementById("cardstack_".concat(this.name));
      var container = container_obj.getBoundingClientRect();
      var index = 0;
      var cum_shift = 0;
      var face = '';
      var shift = '';
      var html = '';
      var gap = this.card_width / this.overlap;
      var num_face_down = 0;
      var _iterator = _createForOfIteratorHelper(this.cards),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var card = _step.value;
          if (this.mod.isFaceDown(card)) {
            num_face_down++;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      num_face_down = Math.max(0, num_face_down - 1);
      if (this.orientation == 'left' || this.orientation == 'right') {
        if (container.width < (this.cards.length - 1) * gap + this.card_width) {
          gap = Math.ceil((container.width - this.card_width) / (this.cards.length - 1));
          console.log('Container: ' + container.width, 'Cards: ' + this.cards.length, 'New Gap: ' + gap);
        }
      } else if (this.orientation == 'up' || this.orientation == 'down') {
        var card_height = this.card_width * this.card_height_ratio;
        gap = Math.ceil(gap * this.card_height_ratio);
        var needed_height = num_face_down * gap / 4 + (this.cards.length - num_face_down - 2) * gap + card_height;
        if (container.height < needed_height) {
          //console.log("num cards: " + this.cards.length, "facedown: " + num_face_down);
          //console.log("Container: " + container.height, "Needed: " + needed_height);

          gap = (container.height - card_height) / (this.cards.length - num_face_down - 1 + num_face_down / 4);
          //console.log("New Gap: " + gap);
        }
      }
      gap = Math.max(gap, 4);
      var _iterator2 = _createForOfIteratorHelper(this.cards),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _card = _step2.value;
          if (face == 'faceup') {
            cum_shift += gap;
          } else if (face == 'facedown') {
            cum_shift += gap / 4;
          } else {
            cum_shift = 0;
          }

          //This test is for how much we shift the next card...
          face = this.mod.isFaceDown(_card) ? 'facedown' : 'faceup';
          if (this.orientation == 'left') {
            shift = "right:".concat(cum_shift, "px;");
          } else if (this.orientation == 'right') {
            shift = "left:".concat(cum_shift, "px;");
          } else if (this.orientation == 'up') {
            shift = "bottom:".concat(cum_shift, "px;");
          } else if (this.orientation == 'down') {
            shift = "top:".concat(cum_shift, "px;");
          }
          html += "<div id=\"cardstack_".concat(this.name, "_").concat(index, "\" \n                  class=\"card-slot ").concat(face, "\" \n                  style=\"z-index:").concat(index, ";").concat(shift, "\">").concat(this.mod.returnCardImageHTML(_card), "</div>");
          index++;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      container_obj.innerHTML = html;
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {}
  }, {
    key: "push",
    value: function push(card) {
      var rerender = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      if (!card) {
        console.warn('Pushing undefined card to stack');
        console.trace();
      }
      this.cards.push(card);
      if (rerender) {
        this.render();
      }
    }
  }, {
    key: "pop",
    value: function pop() {
      var rerender = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var card = '';
      if (this.cards.length > 0) {
        card = this.cards.pop();
      }
      if (rerender) {
        this.render();
      }
      return card;
    }
  }, {
    key: "getCardCount",
    value: function getCardCount() {
      return this.cards.length;
    }
  }, {
    key: "getTopCardElement",
    value: function getTopCardElement() {
      if (this.cards.length > 0) {
        return document.getElementById("cardstack_".concat(this.name, "_").concat(this.cards.length - 1));
      }
      return document.getElementById("cardstack_".concat(this.name, "_empty"));
    }
  }, {
    key: "getTopCardValue",
    value: function getTopCardValue() {
      if (this.cards.length > 0) {
        return this.cards[this.cards.length - 1];
      }
      return null;
    }

    /**
     *  The game mod should pass a test function returning true or false
     *  Any card for which the value is true will have cs-selectable added to its class list
     *  and the specified callback added as a click event
     *
     *  The test function passes index of card and the game-cardstack class as parameters, since
     *  this class includes a reference to the game module, any data or functions native to
     *  the game module are readily accessible without worrying about *this*
     *
     *  The callback passes the game-cardstack class and the index of the card which was selected
     *
     */
  }, {
    key: "applyFilter",
    value: function applyFilter() {
      var _this = this;
      var test = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var top_card_only = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      //this.removeFilter();
      this.render();
      var added_filter = 0;
      if (!test || !callback) {
        console.warn('Applying null filter');
        return;
      }

      //Special case for empty stacks (placement, yo!)
      if (this.cards.length == 0) {
        if (test(-1, this)) {
          var card_obj = document.getElementById("cardstack_".concat(this.name, "_empty"));
          if (card_obj) {
            card_obj.classList.add('cs-selectable');
            card_obj.onclick = function (e) {
              callback(_this, -1, e);
            };
          } else {
            console.warn("cardstack_".concat(this.name, "_empty not rendered!"));
          }
          added_filter++;
        }
      } else {
        //Normal card selection or processing
        var i = top_card_only ? this.cards.length - 1 : 0;
        var _loop = function _loop() {
          if (test(i, _this)) {
            var _card_obj = document.getElementById("cardstack_".concat(_this.name, "_").concat(i));
            if (_card_obj) {
              var card_index = i;
              _card_obj.classList.add('cs-selectable');
              _card_obj.onclick = function (e) {
                callback(_this, card_index, e);
              };
              added_filter++;
            } else {
              console.warn("cardstack_".concat(_this.name, "_").concat(i, " not rendered!"));
            }
          }
        };
        for (; i < this.cards.length; i++) {
          _loop();
        }
      }
      return added_filter;
    }
  }, {
    key: "removeFilter",
    value: function removeFilter() {
      var card_objs = document.querySelectorAll("#cardstack_".concat(this.name, " .card-slot"));
      var _iterator3 = _createForOfIteratorHelper(card_objs),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var card = _step3.value;
          card.classList.remove('cs-selectable');
          card.classList.remove('cs-selected');
          card.onclick = null;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      var stack_obj = document.getElementById("cardstack_".concat(this.name));
      if (stack_obj) {
        stack_obj.classList.remove('cs-selectable');
        stack_obj.classList.remove('cs-selected');
        stack_obj.onclick = null;
      }
    }
  }, {
    key: "markSelected",
    value: function markSelected() {
      var card_index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
      if (card_index < 0) {
        var card_objs = document.querySelectorAll("#cardstack_".concat(this.name, " .card-slot"));
        var _iterator4 = _createForOfIteratorHelper(card_objs),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var card = _step4.value;
            card.classList.add('cs-selected');
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      } else {
        for (var i = card_index; i < this.cards.length; i++) {
          var card_obj = document.querySelector("#cardstack_".concat(this.name, "_").concat(i));
          if (card_obj) {
            card_obj.classList.add('cs-selected');
          }
        }
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      this.cards = [];
      this.initialized = false;
    }
  }]);
}();
module.exports = GameCardStack;